import { MathUtils } from 'three'

export const convertRotationToRadians = (
  rotationInDegrees: [number, number, number]
): [number, number, number] => [
  MathUtils.degToRad(rotationInDegrees[0]),
  MathUtils.degToRad(rotationInDegrees[1]),
  MathUtils.degToRad(rotationInDegrees[2]),
]
